import React, { Component, Suspense } from 'react'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import { CSpinner } from '@coreui/react-pro'
import './scss/style.scss'

import LocalStorageService from './services/LocalStorageService'
import { AppProvider } from './context/AppContext'
import { ApolloProvider, ApolloClient, InMemoryCache } from '@apollo/client'

import { mensagemAlerta, mensagemErro, mensagemSucesso } from './components/Toastr'
import { apiUrl } from './const'

const Recuperar = React.lazy(() => import('./views/pages/recuperar'))
const Alterar = React.lazy(() => import('./views/pages/alterarsenha'))

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
// const Termo = React.lazy(() => import('./views/pages/termo/Termo'))
// const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

// Email App
// const EmailApp = React.lazy(() => import('./views/apps/email/EmailApp'))

function getToken() {
  const cmia_data = LocalStorageService.obterItem('_pmpv-cmia')
  if (cmia_data) {
    return cmia_data.jwt
  }
  return ''
}

const client = new ApolloClient({
  uri: `${apiUrl}/graphql`,
  headers: {
    Authorization: `Bearer ${getToken()}`,
  },
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          requerentes: {
            keyArgs: false,
            merge(existing = [], incoming) {
              return [...existing, ...incoming]
            },
          },
        },
      },
    },
  }),
})

const loading = (
  <div className="pt-3 text-center">
    <CSpinner color="primary" />
  </div>
)

const isUsuarioAutenticado = () => {
  const cmia_data = LocalStorageService.obterItem('_pmpv-cmia')
  if (cmia_data) {
    const jwt = cmia_data
    if (jwt) {
      return true
    } else {
      return false
    }
  }
  return false
}
class App extends Component {
  render() {
    return (
      <ApolloProvider client={client}>
        <AppProvider toast={{ mensagemErro, mensagemAlerta, mensagemSucesso }}>
          <BrowserRouter>
            {/* <Suspense fallback={<CSpinner color="primary" />}> */}
            <Suspense fallback={loading}>
              <Switch>
                <Route
                  exact
                  path="/login"
                  name="Login Page"
                  render={(props) =>
                    !isUsuarioAutenticado() ? <Login {...props} /> : <Redirect to={`/`} />
                  }
                />
                {/* <Route
              exact
              path="/register"
              name="Register Page"
              render={(props) => <Register {...props} />}
            /> */}
                <Route
                  exact
                  path="/reset-password"
                  name="Alterar Senha"
                  render={(props) => <Alterar {...props} />}
                />
                <Route
                  exact
                  path="/recover"
                  name="Recuperar Senha"
                  render={(props) => <Recuperar {...props} />}
                />
                <Route
                  exact
                  path="/404"
                  name="Page 404"
                  render={(props) => <Page404 {...props} />}
                />
                <Route
                  exact
                  path="/500"
                  name="Page 500"
                  render={(props) => <Page500 {...props} />}
                />
                {/* <Route
                path="/apps/email"
                name="Email App"
                render={(props) => <EmailApp {...props} />}
              /> */}
                {/* <Route
                path="/"
                name="Home"
                render={(props) =>
                  isUsuarioAutenticado() ? (
                    <DefaultLayout {...props} />
                  ) : (
                    <DefaultLayout {...props} />
                  )
                }
              /> */}
                <Route
                  path="/"
                  name="Home"
                  render={(props) =>
                    isUsuarioAutenticado() ? (
                      <DefaultLayout {...props} />
                    ) : (
                      <Redirect to={`/login`} />
                    )
                  }
                />
              </Switch>
            </Suspense>
          </BrowserRouter>
        </AppProvider>
      </ApolloProvider>
    )
  }
}

export default App
